/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface ColumnDto
 */
export interface ColumnDto {
  /**
   * Table alias or name the column belongs to.
   *
   * @type {string}
   * @memberof ColumnDto
   * @example users
   */
  table: string;

  /**
   * Column name.
   *
   * @type {string}
   * @memberof ColumnDto
   * @example country
   */
  column: string;

  /**
   * Type of the column
   *
   * @type {string}
   * @memberof ColumnDto
   * @example number
   */
  type: ColumnDtoTypeEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum ColumnDtoTypeEnum {
  Number = 'number',
  Timestamp = 'timestamp',
  Other = 'other',
}
